"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TextHelpers = require("./TextHelpers");
Object.keys(_TextHelpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TextHelpers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TextHelpers[key];
    }
  });
});